import { clickNewSignature } from './click-new-sig';
import { creatingSignature } from './creating-sig';
import { blankSignature, optionChoice, osDesginSignature, templateSignature } from './options';
import { carouselNavigation, clickUseTemplate, usingTemplate } from './using-template';

let createSteps = [
  creatingSignature,
  clickNewSignature,
  optionChoice,
  blankSignature,
  osDesginSignature,
  templateSignature,
  usingTemplate,
  carouselNavigation,
  clickUseTemplate
];

export const CREATE_STEPS = createSteps;
